<!--
 * @Author: your name
 * @Date: 2020-12-02 11:17:56
 * @LastEditTime: 2020-12-03 09:55:22
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \h5-ssr\src\components\scrolltop\index.vue
-->

<template>
   <transition name="openAppIco">
        <div class='stick_box' v-show="showFlag"  @click="goTop"  >
          <i>➔</i>          
          <span>{{'Top'}}</span>
        </div>
    </transition>
</template>

<script>
import { onMounted,reactive,ref } from 'vue'
export default {
     setup(){   
       const showFlag = ref(false)
        let timer =null
         const isTop = ref(true)  
       const goTop = ()=>{
               let clientHeight = document.documentElement.clientHeight
      // document.body.scrollTop = document.documentElement.scrollTop = 0
      clearInterval(timer)
      timer = setInterval(function () {
            // 获取滚动条的滚动高度
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            // 用于设置速度差，产生缓动的效果
        var speed = Math.floor(-scrollTop / 2)
        document.documentElement.scrollTop = document.body.scrollTop = scrollTop + speed
        }, 50)     
       }
       
         const handleScroll = ()=>{
              let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
              let clientHeight = document.documentElement.clientHeight
              // 如果滚动高度大于可视区域高度，则显示回到顶部按钮否则隐藏
                  showFlag.value = (scrollTop >= clientHeight )
                  if (scrollTop <= 5) {
                    clearInterval(timer)
                    }
                }
                  onMounted( ()=>{
                   window.addEventListener('scroll',handleScroll)
         })
         return {
           showFlag,
           isTop,
           goTop,
           handleScroll
         }
     },

}
</script>

<style lang='scss' scoped>

.stick_box {

  padding: 3% 0;
  position: fixed;
  right: 4%;
  bottom: 3%;
  width: 60px;
  height: 60px;
  // line-height: .916667rem;
  border-radius: 50%;
  background-color: #fff;
  z-index: 999;
  text-align: center;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  font-size: 18px;
  i{
    font-style: normal;
    display: inline-block;
    transform: rotateZ(-90deg) translateY(-1px);
    align-items: center;
    font-weight: 800;
    font-size: 18px;
  }
  span{
    transform: translateX(1px);
  }
}
.openAppIco-enter,
.openAppIco-leave-to {
   transform: translateX(200px);
  opacity: 0;
}
.openAppIco-enter-active,
.openAppIco-leave-active {
  transition: all 1s;
}
</style>